var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons';
import { DISABLED_ICON_BUTTON_STYLE } from './contants';
import { Button, IconButton } from '@appspotr/ui-kit';
import { NavigationButton } from './NavigationButton';
export var PaginationItem = function (_a) {
    var onPageChange = _a.onPageChange, selectedPage = _a.selectedPage, paginationData = _a.paginationData;
    var type = paginationData.type, page = paginationData.page, disabled = paginationData.disabled, selected = paginationData.selected;
    var goToPreviousPage = function () {
        onPageChange(selectedPage - 2);
    };
    var goToNextPage = function () {
        onPageChange(selectedPage);
    };
    if (type === 'page') {
        return (_jsx(Button, __assign({ onClick: function () { return onPageChange(page - 1); }, type: selected ? 'secondary' : 'outline', disabled: disabled }, { children: page })));
    }
    if (type === 'start-ellipsis' || type === 'end-ellipsis') {
        return (_jsx(IconButton, { icon: faEllipsisH, type: "neutral", disabled: true, iconStyle: DISABLED_ICON_BUTTON_STYLE }));
    }
    if (type === 'previous') {
        return (_jsx(NavigationButton, { onNavigate: goToPreviousPage, disabled: disabled }));
    }
    if (type === 'next') {
        return (_jsx(NavigationButton, { onNavigate: goToNextPage, disabled: disabled, next: true }));
    }
    return _jsx(_Fragment, {});
};
